// Kvitansiya shabloni turi — backenddagi ReceiptTemplate::TYPE_* bilan bir xil
const RECEIPT_TYPE = {
  PAYMENT: {
    code: '1',
    label: 'settings.receipt.types.payment',
  },
  ORDER: {
    code: '2',
    label: 'settings.receipt.types.order',
  },
};

export default RECEIPT_TYPE;
